import BottomNav from "components/minornav";
import React from "react";
import { Outlet } from "react-router";

function PractitionerLayout() {
  return (
    <div className="relative">
      <div className="overflow-y-auto h-screen">
        <Outlet />
      </div>
      <BottomNav />
    </div>
  );
}

export default PractitionerLayout;
